import { memo } from 'react';
import type { ReactNode } from 'react';
import { clsx } from 'clsx';
import styles from './Table.module.scss';

export interface TableCellProps {
    whiteBackground?: boolean;
    children?: ReactNode;
    rowSpan?: number;
    colSpan?: number;
    width?: string;
    className?: string;
    valign?: 'top' | 'middle' | 'bottom';
    borderLeft?: boolean;
    borderRight?: boolean;
    borderTop?: boolean;
    borderBottom?: boolean;
    background?: string;
    onClick?(): void;
}

const TableCell = ({
    whiteBackground = false,
    children,
    rowSpan,
    colSpan,
    width,
    valign = 'middle',
    className = '',
    borderLeft = false,
    borderRight = false,
    borderTop = false,
    borderBottom = false,
    background,
    onClick,
    ...ariaProps
}: TableCellProps) => {
    return (
        <td
            className={clsx(styles.tableCell, className, {
                [styles.whiteBackground]: whiteBackground,
                [styles.borderLeft]: borderLeft,
                [styles.borderRight]: borderRight,
                [styles.borderTop]: borderTop,
                [styles.borderBottom]: borderBottom,
                [styles.clickableRow]: !!onClick,
            })}
            rowSpan={rowSpan}
            colSpan={colSpan}
            style={{ verticalAlign: valign, width, background }}
            onClick={onClick}
            onKeyPress={e => {
                if ([' ', 'Enter'].includes(e.key)) {
                    onClick?.();
                }
            }}
            {...(onClick
                ? {
                      role: 'button',
                      tabIndex: 0,
                  }
                : {})}
            {...ariaProps}
        >
            {children}
        </td>
    );
};

/**
 * @deprecated
 * Please use `TableCell` from `@library`
 */
export default memo(TableCell);
